import { IUserSubscriptionModel } from "@nf/common";
import { useTranslation } from "next-i18next";

export const useSubscriptionPriceLabel = (
  subscription?: IUserSubscriptionModel
): string | undefined => {
  const { t } = useTranslation("translations");

  const price =
    subscription?.NextPaymentPrice !== undefined
      ? `${subscription?.NextPaymentPrice || 0}`
      : undefined;
  const currency = subscription?.NextPaymentCurrency?.toLowerCase();
  const period = subscription?.Period;

  if (!price || !currency) {
    return undefined;
  }

  return `${price} ${currency}.${t(`web_payment_period_${period}`)}`;
};
